import { LenderOffersDetailedI, LenderOfferValueTypesE } from 'src/interfaces/submissions.interfaces';

const HIDDEN_FIELD_TYPES = new Set<string>([LenderOfferValueTypesE.send_offer_rul]);

const HIDDEN_FIELD_IDS = new Set<string>(['decision', 'send_offer_url', 'send_offer_rul']);

/**
 * Determines whether an fp_detailed_app field should be visible to applicants.
 * Filters out internal fields (e.g. Send Offer URL, Decision) that are only
 * relevant for internal/admin use.
 */
export const isApplicantVisibleField = (field: LenderOffersDetailedI): boolean => {
  if (!field.show) return false;
  if (HIDDEN_FIELD_TYPES.has(field.type)) return false;
  if (HIDDEN_FIELD_IDS.has(field.id)) return false;
  return true;
};
